<template>
    <div class="stateInventory responsive-menu">
      <div class="responsive-menu__child">
        <PageHeader
          title="Working Inventory - Low Stock"
          :links="[
            { name: 'home', label: 'Home' },
            { name: 'reports', label: 'Reports' },
            { name: 'inventoryReport', label: 'Inventory' },
            {
              name: 'inventoryWorkingCount',
              label: 'Working Inventory - Low Stock',
            },
          ]"
          @export="exportToCsv"
          :disableExport="!reportData"
        />
        <br class="no-print" />
        <ReportFilter
          class="no-print"
          :filterByItemType="true"
          @submit-filter="performGetReport"
          :isLoading="inventoryTransactions"
        />
        <div class="report-container">
          <!-- This could be a component -->
          <div class="report-body" v-if="reportData">
            <table id="table-report">
              <thead>
                <tr class="report-body__row report-body__row--header"></tr>
                <tr>
                  <th align="left">Item Id</th>
                  <th align="left">Batch #</th>
                  <th align="left">Supplier</th>
                  <th align="left">Group</th>
                  <th align="left">Grams</th>
                  <th align="left">Product</th>
                  <th align="right">Batch WI Qty</th>
                  <th align="right">Batch Avail Qty</th>
                  <th align="right">Product Qty</th>
                </tr>
              </thead>

              <tbody>
                <tr class="report-body__row"></tr>
                <tr v-for="(record, index) in reportData.records" :key="index">
                    <td>{{ record.item }}</td>
                    <td class="batch">{{ record.batchId }}</td>
                    <td>{{ record.supplier }}</td>
                    <td>{{ record.group }}</td>
                    <td>{{ record.grams }}</td>
                    <td>{{ record.name }}</td>
                    <td align="right">{{ record.quantityWorkingInventory }}</td>
                    <td align="right">{{ record.quantityAvailable }}</td>
                    <td align="right">{{ record.quantityOnHandProduct }}</td>
                </tr>
              </tbody>
              <tr class="skip-export">
                <td colspan="100%">
                  <hr class="line1" />
                </td>
              </tr>
              <tr>
                <td colspan="6">Total</td>
                <td align="right">
                  {{ reportData.total.quantityWorkingInventory }}
                </td>
                <td align="right">
                  {{ reportData.total.quantityAvailable }}
                </td>
                <td align="right">
                  {{ reportData.total.quantityOnHandProduct }}
                </td>
              </tr>
              <tr class="skip-export"></tr>
              <tr class="skip-export">
                <td colspan="100%"><hr class="line1" /></td>
              </tr>

            </table>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  import PageHeader from "@/components/Header/Header.vue";
  import ReportHelper from "@/lib/report/index.js";
  import { mapActions, mapGetters } from "vuex";
  import ReportFilter from "@/components/ReportFilter/ReportFilter";
  import Utilities from "@/lib/Utilities";

  export default {
    data() {
      return {
        reportData: undefined,
        Utilities,
        reportType: undefined,
        selectedPeriod: undefined,
        selectedReportFor: undefined,
        selectedReportSaleType: undefined,
        filterDropdown: undefined,
      };
    },
    components: {
      PageHeader,
      ReportFilter,
    },
    created: function () {
      this.setPageTitle("Working Inventory - Low Stock");
    },
    mounted: function () {
      const today = new Date();
      this.selectedPeriod = {
        from: new Date(new Date().setDate(today.getDate() - 7)),
        to: today,
      };
    },
    computed: {
      ...mapGetters({
        loadingStatus: "reports/loadingStatus",
        inventoryTransactions: "reports/inventoryTransactions",
      }),
    },
    methods: {
      ...mapActions({
        getSalesTransactions: "reports/getInventoryTransactions",
      }),
      performGetReport(filter) {
        let reportType = "inventoryWorkingCount";
        this.getSalesTransactions({
          reportType,
          ...filter,
          positiveCallback: (data) => {
            this.reportData = data;
          },
        });
      },
      exportToCsv() {
        var table = document.getElementById("table-report");
        ReportHelper.exportToExcel(table, "inventoryWorkingCount");
      },
    },
  };
  </script>

  <style lang="scss">
  @import "./_inventoryWorkingCount.scss";